import React, {Component} from 'react'
import classNames from 'classnames'
import ArticlesList from '../ArticlesList/ArticlesList'
import logger from 'logger'
import FeaturedArticlesSection from '../../components/FeaturedArticlesSection/FeaturedArticlesSection'

class ArticlesSection extends Component {
  constructor (props) {
    super(props)
    this.state = {
      articles: props.articles,
      loading: false,
      totalArticles: this.props.totalArticles,
      mobileOffset: props.mobileOffset
    }
    this.loadMoreArticles = this.loadMoreArticles.bind(this)
  }

  async componentDidMount () {
    if (this.props.articles.length === 0) {
      logger.warn('No articles provided, so the articles list is being hidden.')
    }
  }

  async loadMoreArticles () {
    if (this.state.loading) return
    if (this.state.articles.length === this.state.totalArticles) {
      return this.setState({
        mobileOffset: Math.max(0, this.state.mobileOffset - 3)
      })
    }
    this.setState({
      loading: true
    })
    const { loader } = this.props
    const { articles } = await loader(3, Math.floor(this.state.articles.length / 3))
    this.setState({
      articles: this.state.articles.concat(articles),
      loading: false,
      mobileOffset: this.state.mobileOffset - (3 - articles.length)
    })
  }

  renderFeatured () {
    const topArticles = this.props.articles.slice(0, 3)
    return this.props.featured ? [
      <FeaturedArticlesSection className='CategoryPage__featuredArticles' articles={topArticles} key={0} />,
      <hr key={1} />
    ] : null
  }


  getArticleList () {
    const {articles} = this.state
    const offset = (this.props.isMobileLayout ? this.state.mobileOffset : 0)
    const list = this.props.featured ? articles.slice(3) : articles
    return list.slice(0, list.length - offset)
  }

  render () {
    const {className, title, hasLabel} = this.props
    const {articles} = this.state
    if (!articles || articles.length === 0) {
      return null
    }
    return (
      <div className='CategoryPage__articles'>
        {this.renderFeatured()}
        <div className={classNames([
          'ArticlesSection',
          className,
          {
            'ArticlesSection--noHeader': !title
          }
        ])}>
          {
            title && (
              <header className='ArticlesSection__header' aria-label={title}>
                <h3 className='ArticlesSection__header__title'>{title}</h3>
              </header>
            )
          }
          <ArticlesList hasLabel={hasLabel} articles={this.getArticleList()} className='ArticlesSection__list' />
        </div>
      </div>
    )
  }
}

ArticlesSection.defaultProps = {
  articles: [],
  className: ''
}

export default ArticlesSection



// WEBPACK FOOTER //
// ./client/components/ArticlesSection/ArticlesSection.js